export default "__VITE_ASSET__DFL4yC5J__"